(function () {
  let reinitTimer = null;
  let isBuilding = false;

  function getGalleryItems(grid) {
    return Array.from(grid.querySelectorAll(':scope > li')).filter((item) => {
      return item.querySelector('.product-media__image, img');
    });
  }

  function getImageSignature(items) {
    return items
      .map((item) => {
        const img =
          item.querySelector('.product-media__image') ||
          item.querySelector('img');
        return img ? (img.currentSrc || img.src || '') : '';
      })
      .join('|');
  }

  function setActive(thumbButtons, index) {
    thumbButtons.forEach((btn, i) => {
      const active = i === index;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function buildOrUpdateThumbs(gallery) {
    const grid = gallery.querySelector('.media-gallery__grid');
    if (!grid) return;

    const items = getGalleryItems(grid);
    const signature = getImageSignature(items);

    if (items.length <= 1) {
      const oldWrap = gallery.querySelector('.lb-grid-thumbs-wrap');
      if (oldWrap) oldWrap.remove();
      gallery.classList.remove('has-lb-grid-thumbs');
      if (gallery._lbThumbsObserver) {
        gallery._lbThumbsObserver.disconnect();
        gallery._lbThumbsObserver = null;
      }
      gallery._lbThumbsSignature = '';
      return;
    }

    const existingWrap = gallery.querySelector('.lb-grid-thumbs-wrap');
    const existingRail = gallery.querySelector('.lb-grid-thumbs');

    if (existingWrap && existingRail && gallery._lbThumbsSignature === signature) {
      return;
    }

    if (gallery._lbThumbsObserver) {
      gallery._lbThumbsObserver.disconnect();
      gallery._lbThumbsObserver = null;
    }

    let wrap = existingWrap;
    let rail = existingRail;

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'lb-grid-thumbs-wrap';
      wrap.style.opacity = '0';
      wrap.style.transition = 'opacity .18s ease';
      gallery.appendChild(wrap);
    }

    if (!rail) {
      rail = document.createElement('div');
      rail.className = 'lb-grid-thumbs';
      wrap.appendChild(rail);
    }

    rail.innerHTML = '';
    const thumbButtons = [];

    items.forEach((item, index) => {
      const sourceImg =
        item.querySelector('.product-media__image') ||
        item.querySelector('img');

      if (!sourceImg) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lb-grid-thumb';
      btn.setAttribute('aria-label', `Go to image ${index + 1}`);

      const img = document.createElement('img');
      img.src = sourceImg.currentSrc || sourceImg.src || '';
      img.alt = sourceImg.alt || '';
      img.loading = 'lazy';

      btn.appendChild(img);

      btn.addEventListener('click', () => {
        item.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });

      rail.appendChild(btn);
      thumbButtons.push(btn);
    });

    gallery.classList.add('has-lb-grid-thumbs');
    gallery._lbThumbsSignature = signature;

    setActive(thumbButtons, 0);

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        if (!visible.length) return;

        const activeItem = visible[0].target;
        const activeIndex = items.indexOf(activeItem);

        if (activeIndex !== -1) {
          setActive(thumbButtons, activeIndex);
        }
      },
      {
        root: null,
        rootMargin: '-15% 0px -55% 0px',
        threshold: [0.2, 0.4, 0.6]
      }
    );

    items.forEach((item) => observer.observe(item));
    gallery._lbThumbsObserver = observer;

    requestAnimationFrame(() => {
      wrap.style.opacity = '1';
    });
  }

  function initLbPdpGridThumbs() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    if (isBuilding) return;

    isBuilding = true;

    const galleries = document.querySelectorAll(
      '.product-information__media .media-gallery--grid'
    );

    galleries.forEach((gallery) => {
      buildOrUpdateThumbs(gallery);
    });

    isBuilding = false;
  }

  function reinitLbPdpGridThumbs(delay = 180) {
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(() => {
      initLbPdpGridThumbs();
    }, delay);
  }

  window.lbInitPdpGridThumbs = initLbPdpGridThumbs;
  window.lbReinitPdpGridThumbs = reinitLbPdpGridThumbs;

  document.addEventListener('DOMContentLoaded', function () {
    reinitLbPdpGridThumbs(220);
  });

  document.addEventListener('shopify:section:load', function () {
    reinitLbPdpGridThumbs(220);
  });

  document.addEventListener('change', function (e) {
    if (
      e.target.matches('variant-radios input[type="radio"]') ||
      e.target.matches('variant-selects select') ||
      e.target.matches('input[type="radio"][name*="option"]') ||
      e.target.matches('select[name*="option"]')
    ) {
      reinitLbPdpGridThumbs(220);
    }
  });

  document.addEventListener('variant:change', function () {
    reinitLbPdpGridThumbs(220);
  });

  const mediaRoot = document.querySelector('.product-information__media');
  if (mediaRoot) {
    let moTimer = null;

    const mo = new MutationObserver(() => {
      clearTimeout(moTimer);
      moTimer = setTimeout(() => {
        reinitLbPdpGridThumbs(100);
      }, 100);
    });

    mo.observe(mediaRoot, {
      childList: true,
      subtree: true
    });
  }
})();